import { Button } from "@/components/core/buttons/Button";
import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";

import { DEFAULT_SITE_LENGTH } from "./ChromeShortcut";

export function ChromeTopSitesPermission({
    onSubmitTopSitesPermission
}: {
    onSubmitTopSitesPermission: (granted: boolean) => void;
}) {
    return (
        <div className="flex w-[var(--home-board-topSites-permission-width)] flex-col items-center gap-[21px]">
            <ul className="flex w-full flex-wrap items-center justify-center">
                {Array.from({ length: DEFAULT_SITE_LENGTH + 1 }).map(
                    (_, index) => (
                        <div className="aspect-square w-20 p-4" key={index}>
                            <svg
                                width="100%"
                                height="100%"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="100%"
                                    height="100%"
                                    rx={12}
                                    ry={12}
                                    fill="var(--grey-100)"
                                />
                            </svg>
                        </div>
                    )
                )}
            </ul>

            <div>
                <div className="before:animate-ping-custom relative -left-1 top-3 inline-block h-3.5 w-3.5 rounded-full bg-orange-500 before:absolute before:left-0 before:top-0 before:h-[65%] before:w-[65%] before:rounded-full before:border-[2.7px] before:border-orange-500 before:content-['']" />

                <div className="flex items-center gap-3 rounded-xl border border-line bg-grey-50 px-4 py-3">
                    <Text variant="caption2" color="text.primary">
                        바로가기 아이콘을 사용하시겠어요?
                    </Text>
                    <div className="flex items-center gap-2">
                        <Button
                            variant="filled"
                            color="grey"
                            size="small"
                            onClick={() => onSubmitTopSitesPermission(false)}
                        >
                            다음에 할게요
                        </Button>
                        <Button
                            variant="filled"
                            color="primary"
                            size="small"
                            onClick={async () => {
                                const granted =
                                    await chrome.permissions.request({
                                        permissions: ["topSites"]
                                    });

                                onSubmitTopSitesPermission(granted);
                            }}
                        >
                            사용 할래요
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
